import React from 'react';
import styles from './style.module.css';
import StepSixForm from '../../components/forms/step-six';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Payment Frequency Options</h1>
        <StepSixForm/>
    </div>
);
